import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-wrap flex-row gap-1"
}
const _hoisted_3 = ["href", "download"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled", "aria-labelledby", "onUpdate:modelValue"]
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-redlining" }, null, -1)
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_ParempiGrid = _resolveComponent("ParempiGrid")!

  return (this.nodeJoins != null && this.nodeJoins.length > 0)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('review.upload.page.comments')), 1),
        _createVNode(_component_ParempiGrid, {
          class: "flex-grow-1 flex-min-height-0",
          columns: this.columns,
          items: this.nodeJoins,
          rowPosFactory: this.rowPosFactory,
          rowPosIncrementor: this.rowPosIncrementor,
          storageKey: "/cdes/edit/upload/editCommentList/columnWidths"
        }, {
          node: _withCtx(({ item }) => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$s(item.reviewCycleNodeName)), 1)
          ]),
          reviewer: _withCtx(({ item, rowPos }) => [
            _createElementVNode("div", null, _toDisplayString(this.getReviewerString(item, rowPos)), 1)
          ]),
          realmShort: _withCtx(({ item, rowPos }) => [
            _createElementVNode("div", null, _toDisplayString(this.getRealmString(item, rowPos)), 1)
          ]),
          date: _withCtx(({ item, rowPos }) => [
            _createElementVNode("div", null, _toDisplayString(this.getDateString(item, rowPos)), 1)
          ]),
          review: _withCtx(({ item, rowPos }) => [
            _createElementVNode("div", {
              innerHTML: this.getComment(item, rowPos)
            }, null, 8, _hoisted_1),
            (this.getAttachments(item, rowPos).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getAttachments(item, rowPos), (attachment) => {
                    return (_openBlock(), _createElementBlock("a", {
                      class: "btn btn-sm btn-outline-secondary",
                      key: attachment.attachmentId,
                      href: _ctx.getAttachmentLink(attachment),
                      download: attachment.attachmentOriginalName
                    }, _hoisted_5, 8, _hoisted_3))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          result: _withCtx(({ item, rowPos }) => [
            _createElementVNode("div", null, _toDisplayString(this.getResult(item, rowPos)), 1)
          ]),
          comment: _withCtx(({ item, rowPos }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([ this.getResultJoin(item, rowPos) ], (resultJoin) => {
              return _withDirectives((_openBlock(), _createElementBlock("textarea", {
                key: resultJoin.reviewCycleNodeId,
                disabled: this.disabled,
                "aria-labelledby": _ctx.$id('commentHeading'),
                class: "form-control",
                "onUpdate:modelValue": ($event: any) => ((resultJoin.reviewCyclePositionResultComment) = $event)
              }, "\n      ", 8, _hoisted_6)), [
                [_vModelText, resultJoin.reviewCyclePositionResultComment]
              ])
            }), 128)),
            _createElementVNode("a", {
              class: "text-decoration-none text-body text-end",
              href: _ctx.getRedliningLink(this.getResultJoin(item, rowPos))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('general.redlining')) + " ", 1),
              _hoisted_8
            ], 8, _hoisted_7)
          ]),
          reviewCycleCommentOption: _withCtx(({ item, rowPos }) => [
            (item.activeNodeReviewCycleCommentTypeId != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getCommentOptions(item.activeNodeReviewCycleCommentTypeId), (commentOption) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: commentOption.id
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([ this.getResultJoin(item, rowPos) ], (resultJoin) => {
                        return (_openBlock(), _createBlock(_component_RadioButton, {
                          key: resultJoin.reviewCycleNodeId,
                          disabled: this.disabled,
                          mode: "flex",
                          name: resultJoin.reviewCyclePositionResultId,
                          value: commentOption.id,
                          label: _ctx.$s(commentOption.name),
                          selected: resultJoin.reviewCyclePositionResultReviewCycleCommentOptionId,
                          "onUpdate:selected": ($event: any) => ((resultJoin.reviewCyclePositionResultReviewCycleCommentOptionId) = $event),
                          onClick: ($event: any) => (this.optionChosen(commentOption))
                        }, null, 8, ["disabled", "name", "value", "label", "selected", "onUpdate:selected", "onClick"]))
                      }), 128))
                    ], 64))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "items", "rowPosFactory", "rowPosIncrementor"])
      ], 64))
    : _createCommentVNode("", true)
}